import React from 'react';

const IconArrowLeft = () => (
  <svg width="42" height="25" viewBox="0 0 42 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.0823 0.900655L13.2436 -6.06615e-07L1.07093e-06 12.25L13.2436 24.5L14.0823 23.5993L2.4767 12.8644L42 12.8644L42 11.6352L2.4767 11.6352L14.0823 0.900655Z" fill="currentColor" />
  </svg>
);

export default IconArrowLeft;
